import { Component, inject, signal } from '@angular/core';
import { InfoText, IPopupModelV2, ModalChild } from '@mwe/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { TranslatePipe } from '@ngx-translate/core';
import { ModalComponent } from '../modal/modal.component';
import { MvnoInfoTextPopupComponent } from './mvno-info-text-popup.component';

@Component({
  selector: 'mwe-info-text-popup',
  templateUrl: './info-text-popup.component.html',
  imports: [TranslatePipe, ModalComponent, MvnoInfoTextPopupComponent],
})
export class InfoTextPopupComponent implements ModalChild {
  private activeModal = inject(NgbActiveModal);

  popupModel = signal<IPopupModelV2>(null);

  // is being passed by popupService
  loadedData: InfoText;

  closePopup(): void {
    this.activeModal.close('OK');
  }
}
